import React from 'react';
import { SuccessModal as SuccessModalType } from '@/types/modal';
import { SuccessModal } from '@/components/molecules/common/Modal';

const View: React.FC<{ modal: SuccessModalType }> = ({ modal }) => {
  return (
    <SuccessModal
      title={modal.title}
      onClose={modal.onClose}
    />
  );
};

export default View;
